import React, { Component } from "react";
import $ from "jquery";
import "magnific-popup";

class Gallery extends Component {
  // eslint-disable-next-line
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    function popup() {
      $(".gallery-thumb").magnificPopup({
        type: "image",
        gallery: {
          enabled: true,
        },
      });
    }
    popup();
  }
  render() {

    return (
      <div className="section pt-0" style={{ padding: '5px 0', backgroundColor: this?.props?.websiteBackgroundColor }}>
        <div className="gallery-section">
          <div className="row no-gutters">
            <div
              key={1}
              className="col-xl-3 col-lg-3 col-md-3 col-12 p-0"
            >
              <a href={`${this.props.pathUrl}/assets/default/gallery/default1.jpg`} className="gallery-thumb">
                <img src={`${this.props.pathUrl}/assets/default/gallery/default1.jpg`} alt="gallery" />
              </a>
            </div>
            <div
              key={2}
              className="col-xl-3 col-lg-3 col-md-3 col-12 p-0"
            >
              <a href={`${this.props.pathUrl}/assets/default/gallery/default2.jpg`} className="gallery-thumb">
                <img src={`${this.props.pathUrl}/assets/default/gallery/default2.jpg`} alt="gallery" />
              </a>
            </div>
            <div
              key={3}
              className="col-xl-3 col-lg-3 col-md-3 col-12 p-0"
            >
              <a href={`${this.props.pathUrl}/assets/default/gallery/default3.jpg`} className="gallery-thumb">
                <img src={`${this.props.pathUrl}/assets/default/gallery/default3.jpg`} alt="gallery" />
              </a>
            </div>
            <div
              key={4}
              className="col-xl-3 col-lg-3 col-md-3 col-12 p-0"
            >
              <a href={`${this.props.pathUrl}/assets/default/gallery/default4.jpg`} className="gallery-thumb">
                <img src={`${this.props.pathUrl}/assets/default/gallery/default4.jpg`} alt="gallery" />
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Gallery;
